module.exports = __webpack_public_path__ + "static/media/scarecrow_true.8ea10708.png";